export const SENTRY_IGNORE_LIST = [
  'ResizeObserver loop limit exceeded', // package 'resize-observer-polyfill' error
  'ResizeObserver loop completed with undelivered notifications', // package 'resize-observer-polyfill' error
  'Importing a module script failed', // Deployment (Vitejs bundle regeneration) errors
  /Network Error/i, // Network related error
  /Fetch Error/i, // Network related error
  'Large HTTP payload', // Large HTTP payload error
  'Connection lost', // Connection lost error
  'Client is not connected', // Containing client is not connected
];
